"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _remoteComponents = require("@olxbr/remote-components");
var _styledComponents = require("styled-components");
var _dsWeb = require("@olxbr/ds-web");
var _selectors = require("../../../selectors");
var _propTypes = require("prop-types");
var _actions = require("../../../actions");
var _platform = require("../../../helpers/platform");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function MiniProfileRemoteComponent(_ref) {
  var partnerId = _ref.partnerId,
    onPressRedirectToUserProfile = _ref.onPressRedirectToUserProfile,
    fallback = _ref.fallback,
    isAdview = _ref.isAdview;
  var miniProfileProps = {
    url: 'https://autos-buyers-remotes.olx.com.br/mini-profile-chat-ui-web/v1/remoteEntry.js',
    // 'http://local.olx.com.br:3010/remoteEntry.js',
    scope: 'mini_profile_chat_ui_web',
    module: './ViewProfile',
    loading: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
      width: _platform.isMsite ? '40px' : '60px',
      height: _platform.isMsite ? '40px' : '20px'
    }),
    errorCallback: function errorCallback(_, __, extraData) {
      (0, _dsWeb.sendToLurker)({
        eventType: 'error',
        objectName: 'miniprofile',
        objectDetail: 'error_loading',
        data: extraData
      });
    },
    accountId: Number.parseInt(partnerId),
    useNewChatVersion: true,
    profileCTACallback: onPressRedirectToUserProfile,
    isAdview: isAdview
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_remoteComponents.FederatedRemoteComponent, _objectSpread(_objectSpread({}, miniProfileProps), {}, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: fallback()
    })
  }));
}
MiniProfileRemoteComponent.propTypes = {
  partnerId: _propTypes.string,
  onPressRedirectToUserProfile: _propTypes.func.isRequired,
  fallback: _propTypes.func.isRequired,
  theme: _propTypes.object.isRequired,
  isAdview: _propTypes.bool
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    partnerId: (0, _selectors.getCurrentPartnerId)(state)
  };
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps)((0, _styledComponents.withTheme)(MiniProfileRemoteComponent));